export const UPDATE_TRACKING = 'UPDATE_TRACKING';

export const updateTracking = (payload) => ({
    type: UPDATE_TRACKING,
    payload,
});

export const updateTrackingPageName = (trackingString, pageName) => {
    /**
     * Updates the name of the page in the tracking string.
     *
     * This is set by the Zeno Data Layer and doesn't use any attribution in the model,
     * hence we need to parse, update and re-stringify.
     */

    if (!trackingString) {
        return updateTracking(undefined);
    }

    const parsedTracking = JSON.parse(trackingString);
    parsedTracking.p.t = pageName;

    return updateTracking(JSON.stringify(parsedTracking));
};

export default (state = false, action) =>
    action.type === UPDATE_TRACKING ? action.payload : state;
